<div
  class="card-container usecase-card d-flex flex-column h-100 position-relative"
>
  <div
    *ngIf="useCaseItem?.usecaseType === 'Tryout'"
    class="usecase-tryout position-absolute"
  >
    <img width="107" height="20" src="assets/images/tryout.svg" alt="Tryout" />
  </div>

  <div class="card_header">
    <app-card-owner-detail>
      <div class="p-0 usecase-heading">
        <app-card-heading [title]="useCaseItem?.name">
          {{ useCaseItem?.name }}
        </app-card-heading>
      </div>
      <img
        class="rounded-circle"
        imagePlaceholder
        imageFallBack="assets/images/fallback-image.png"
        ngProjectAs="[profileImage]"
        width="46"
        height="46"
        [src]="
          useCaseItem?.imageUrl || useCaseItem?.currentOwner?.organization?.logo
        "
        [alt]="useCaseItem?.name || 'Username'"
        [title]="useCaseItem?.name || 'Username'"
        (error)="onError($event, 'assets/images/fallback-image.png')"
      />
    </app-card-owner-detail>

    <div
      class="secondary-color text-xs description"
      [title]="useCaseItem?.shortDescription"
    >
      {{ useCaseItem?.shortDescription }}
    </div>
  </div>

  <div class="mt-auto">
    <div class="px-3 pb-3">
      <div class="d-flex align-items-center gap-2 py-2 chip_overflow">
        <ng-container *ngFor="let chip of useCaseItem?.details?.tag">
          <div *ngIf="chip.tag" class="flex-shrink-0">
            <app-card-chips>{{ chip.tag }}</app-card-chips>
          </div>
        </ng-container>
      </div>

      <div class="d-flex justify-content-between gap-2 my-2 flex-column">
        <app-card-activities
          [artefactType]="artefactType.usecase"
          [artefactId]="useCaseItem.id"
          [upvoteCount]="useCaseItem?.vote?.upvotes"
          [viewCount]="useCaseItem?.stats?.views"
        ></app-card-activities>

        <span class="text-xs secondary-color">
          {{ useCaseItem?.updatedDate | lastUpdatedDays }}
        </span>
      </div>
    </div>

    <hr class="m-0 px-0 text-gray" />

    <div class="org-logo-container">
      <span
        [title]="
          useCaseItem?.currentOwner?.organization?.name ||
            useCaseItem?.details?.sourceOrg?.name | uppercase
        "
      >
        {{
          useCaseItem?.currentOwner?.organization?.name ||
            useCaseItem?.details?.sourceOrg?.name | uppercase
        }}
      </span>
    </div>

    <hr class="px-0 m-0 text-gray" />

    <div class="m-3 d-flex justify-content-between align-items-center">
      <!-- [routerLink]="['/', routes.usecases, routes.details, useCaseItem.slug + '.html']" -->
      <a
        role="button"
        class="btn-tertiary-bordered btn h-auto px-3 py-2"
        (click)="onUseCaseClick(useCaseItem.id)"
      >
        View Details
      </a>

      <!-- <div class="d-flex align-items-center gap-2 flex-wrap"> -->
      <!-- <ng-container *ngIf="userProfile?.id !== useCaseItem?.currentOwner?.id">
          <app-upvote-downvote
            [entityType]="artefactType.usecase"
            [entityDetails]="useCaseItem"
            (onVoteChange)="onVoteChange()"
          ></app-upvote-downvote>
        </ng-container> -->

      <!-- <app-bookmark
          [entityType]="artefactType.usecase"
          [entityId]="useCaseItem.id"
          [isBookmarked]="useCaseItem.isBookmarked"
          (onBookmarkToggle)="toggleBookmark()"
        ></app-bookmark> -->
      <!-- </div> -->
    </div>
  </div>
</div>
